/**
 * 员工类型
 */
export default Object.freeze({
    IN: '业内', // 业内
    OUT: '业外' // 业外
})